import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/brand/logo design.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const LogoDesign = () => {
  const heroData = {
    title: "Professional Logo Design Services",
    description: "Create a memorable visual identity that captures your brand's essence and resonates with your audience. We design timeless, versatile logos that work across all platforms and touchpoints.",
    image: img13,
    imageAlt: "Logo Design",
    features: [
      "Custom logo concepts",
      "Multiple design variations",
      "Scalable vector files",
      "Brand color palette",
      "Typography selection",
      "Usage guidelines",
    ],
    pillars: [
      "Memorable design that creates instant brand recognition",
      "Versatile application across all media and platforms",
      "Timeless aesthetic that evolves with your brand",
    ],
  };

  const journeySteps = [
    {
      title: "Discovery & Research",
      description: "We dive deep into your brand values, target audience, and competitive landscape to inform our creative direction.",
      details: ["Brand questionnaire", "Competitor analysis", "Industry trends", "Target audience insights", "Mood board creation", "Style direction"],
    },
    {
      title: "Concept Development",
      description: "Our designers create multiple unique logo concepts that embody your brand's personality and values.",
      details: ["Sketching & ideation", "3-5 initial concepts", "Typography exploration", "Color palette options", "Symbol development", "Modern & classic styles"],
    },
    {
      title: "Refinement & Feedback",
      description: "We collaborate with you to refine the chosen concept, perfecting every detail until it's exactly right.",
      details: ["Client feedback rounds", "Design adjustments", "Color variations", "Typography refinement", "Spacing & balance", "Multiple applications"],
    },
    {
      title: "Finalization & Delivery",
      description: "Comprehensive delivery package with all file formats, variations, and brand guidelines for consistent usage.",
      details: ["Vector files (AI, EPS, SVG)", "High-res PNG & JPG", "Black & white versions", "Color palette guide", "Usage guidelines", "Source files"],
    },
  ];

  const capabilities = [
    {
      title: "Brand Logos",
      content:
        "Complete brand identity logos that capture your essence with unique symbols, wordmarks, or combination marks.",
    },
    {
      title: "Icon & Symbol Design",
      content:
        "Distinctive icons and symbols that work standalone or as part of your complete logo system.",
    },
    {
      title: "Logo Redesign",
      content:
        "Modernize existing logos while maintaining brand equity and recognition with strategic evolution.",
    },
    {
      title: "Logo System",
      content:
        "Comprehensive logo families with primary, secondary, and responsive variations for all use cases.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "98%", label: "Client satisfaction rate" },
      { value: "50+", label: "Logo variations delivered" },
      { value: "100%", label: "Scalable vector format" },
    ],
    description: "We deliver exceptional logo designs that enhance brand recognition, drive customer trust, and provide long-term value across all applications.",
  };

  const outcomesData = {
    description: "We create professional logos that establish strong brand identity and ensure consistent recognition across all platforms and materials.",
    outcomes: [
      "3-5 unique logo concepts with variations",
      "Full vector files (AI, EPS, SVG, PDF)",
      "High-resolution raster files (PNG, JPG)",
      "Color and monochrome versions",
      "Complete brand color palette",
      "Logo usage and brand guidelines",
    ],
  };

  const whyChooseUs = [
    {
      title: "Award-Winning Designers",
      content:
        "Our team of experienced designers has created logos for startups to Fortune 500 companies across diverse industries.",
    },
    {
      title: "Unlimited Revisions",
      content:
        "We work with you until you're 100% satisfied, refining every detail to perfection.",
    },
    {
      title: "Complete File Package",
      content:
        "Receive all file formats and variations you'll ever need for print, digital, and merchandise applications.",
    },
    {
      title: "Fast Turnaround",
      content:
        "Get your initial logo concepts within 5-7 business days, with final delivery in 2-3 weeks.",
    },
  ];

  const faqs = [
    {
      q: "How long does the logo design process take?",
      a: "Typically, you'll receive initial logo concepts within 5-7 business days. After your feedback and revisions, the final logo package is delivered within 2-3 weeks. Rush services are available for urgent projects."
    },
    {
      q: "What file formats will I receive?",
      a: "You'll receive comprehensive file packages including vector files (AI, EPS, SVG, PDF) for scalability, high-resolution raster files (PNG, JPG) for digital use, and both color and monochrome versions. All source files are included for future edits."
    },
    {
      q: "Can I trademark my new logo?",
      a: "Yes! We create original, unique logos that can be trademarked. We conduct preliminary trademark searches to avoid conflicts, and can connect you with legal experts for trademark registration if needed."
    },
    {
      q: "What if I need my logo in different colors or sizes?",
      a: "Your logo package includes multiple color variations (full color, monochrome, reversed) and vector formats that scale infinitely without quality loss. We also provide usage guidelines for different applications and backgrounds."
    }
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Logo Design"}
            pagesub={"Branding & Design"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Logo Design Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default LogoDesign;
